const TESTING_ENV = "test";
const isDevelopment = process.env.NODE_ENV === "development";
const isTesting = process.env.NODE_ENV === TESTING_ENV;
module.exports = {
    isDevelopment,
    isTesting
};
